/*
 * Created Date: 21-10-2023, 11:55:12 pm
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified: Sat Oct 21 2023
 * Modified By: Peter
 * -----
 * Copyright (c) 2023 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

export const isPlanPersonalVip = plan => {
	return plan && plan?.slug === 'vip'
}

export const isPlanPersonalFree = plan => {
	// console.log('============= plan', plan)
	return !plan || (plan && plan?.price === 0)
}
